import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {outputFormatBadgeClass, outputFormatLabel} from '../../models/output-format.model';
import {BadgePillComponent} from '../badge-pill/badge-pill.component';

/**
 * The shared file-format "pill" — one outlined, colour-coded badge used everywhere a file format
 * is shown (saved-export tiles/list, quick-export file-format step). Single source of the look,
 * label and colour, so the design stays consistent. Renders nothing when the format is null.
 */
@Component({
    selector: 'app-file-format-badge',
    standalone: true,
    imports: [BadgePillComponent],
    template: `
        @let formatLabel = label();
        @if (formatLabel !== null) {
            <app-badge-pill [label]="formatLabel" [colorClass]="colorClass()" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileFormatBadgeComponent {
    readonly format = input.required<string | null>();

    protected readonly label = computed(() => outputFormatLabel(this.format()));
    protected readonly colorClass = computed(() => outputFormatBadgeClass(this.format()));
}
